module.exports = __webpack_public_path__ + "static/media/person-warning.e18f09a4.svg";